import {Component, OnInit, ViewChild, ViewContainerRef} from '@angular/core';
import {TelaExpandidaComponent} from "../TelaExpandida";
import {ConstantsService, ModulosEnum} from "../../fidelidade/ConstantsService";
import {NotificationService} from "@progress/kendo-angular-notification";
import {EmpresaService} from "../../services/empresa.service";
import {PedidosService} from "../../services/pedidos.service";
import {Router} from "@angular/router";


@Component({
  selector: 'app-tela-pedidos',
  templateUrl: './tela-pedidos.component.html',
  styleUrls: ['./tela-pedidos.component.scss']
})
export class TelaPedidosComponent extends TelaExpandidaComponent implements OnInit {
  empresa: any = {};
  moduloFiadoAtivo = false;
  codigoLocalizar = '';
  localizandoPedido = false;
  mensagemLocalizador = '';
  exibirLocalizadorPedido = false;
  @ViewChild('appendTo', { read: ViewContainerRef }) public appendTo: ViewContainerRef;
  constructor(private  constantsService: ConstantsService,  private notificationService: NotificationService,
              private empresasService: EmpresaService, private pedidosService: PedidosService,
              private router: Router) {
    super();
  }

  ngOnInit() {
    this.constantsService.empresa$.subscribe( (empresa) => {
      if (!empresa) return;

      this.empresa = empresa;
      this.moduloFiadoAtivo = this.constantsService.possuiModulo(empresa, ModulosEnum.FIADO);
    });
  }

  alterouAceitarAutomatico(aceitarPedidoAutomatico ) {

   this.empresasService.altereAceitarPedido(aceitarPedidoAutomatico).then( (resp) => {
      this.notificationService.show({
        content: aceitarPedidoAutomatico ? 'Alterado para aceitar pedidos automaticamente!' : "Alterado para não aceitar pedidos automaticamente",
        appendTo: this.appendTo,
        hideAfter: 2000,
        position: { horizontal: "center", vertical: "top" },
        animation: { type: "fade", duration: 800 },
        type: { style: "success", icon: true },
      });
    }).catch((err) => {
     setTimeout(() => {
       this.empresa.aceitarPedidoAutomatico = !aceitarPedidoAutomatico
     }, 500)
     alert(err)
   })
  }

  altereExibicaoLocalizadorPedido() {
    this.exibirLocalizadorPedido = !this.exibirLocalizadorPedido;
    this.mensagemLocalizador = '';
  }

  fecheLocalizadorPedido() {
    this.exibirLocalizadorPedido = false;
    this.mensagemLocalizador = '';
  }

  localizePedidoPorCodigo() {
    if(this.localizandoPedido) return;

    const codigo = String(this.codigoLocalizar || '').trim();

    this.mensagemLocalizador = '';

    if(!/^\d{1,9}$/.test(codigo)) {
      this.mensagemLocalizador = 'Digite um código de pedido válido.';
      return;
    }

    this.localizandoPedido = true;

    this.pedidosService.localizePedidoPorCodigo(codigo).then((pedidos: any[]) => {
      this.localizandoPedido = false;

      if(!pedidos || !pedidos.length) {
        this.mensagemLocalizador = `Nenhum pedido com o código ${codigo} nesta loja.`;
        return;
      }

      this.exibirLocalizadorPedido = false;
      this.router.navigate(['/admin/pedidos/detalhes', pedidos[0].guid]);
    }).catch((erro) => {
      this.localizandoPedido = false;
      this.mensagemLocalizador = erro || 'Não foi possível localizar o pedido.';
    });
  }
}
